import React from 'react';
import { useTranslation } from 'react-i18next';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { createSx } from '../../../../../../../../../../utils';
import EllipsedTypography from '../../../../../../../../../Tooltip/EllipsedTypography';

const sx = createSx({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 1,
    border: '2px solid',
    borderColor: 'primary.outlineVariant',
    borderRadius: '50%',
  },
  name: {
    color: 'primary.onContainer',
  }
});

interface Props {
  name: string;
}

const NoImageAttachmentPreview = ({ name }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} sx={sx.root} data-test-id='no-image-attachment-preview'>
      <Box sx={sx.iconWrapper}>
        <InsertDriveFileOutlinedIcon
          color='primary'
          fontSize='xlarge'
        />
      </Box>
      <EllipsedTypography
        variant='body1'
        sx={sx.name}
        testID='attachment-name'
      >
        {name}
      </EllipsedTypography>
      <Typography
        data-test-id='no-preview-info'
        variant='caption'
        color='neutral.onSurfaceVariant'>
        {t('infoMessage_noPreview')}
      </Typography>
    </Stack>
  );
};

export default NoImageAttachmentPreview;